import React from "react";
import { connect } from "react-redux";
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { HardDrive } from 'lucide-react';

function DiskUsageChart(values) {
    const chartData = [
        { name: 'Used', value: parseFloat(values.used) || 0 },
        { name: 'Free', value: parseFloat(values.available) || 0 }
    ];

    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2 mb-4">
                <HardDrive className="oct_icon" />
                <h3>Disk Usage</h3>
            </div>

            <div className="oct_sys-mem-stats-list-v2 gap-2">
                <div className="stat-row">
                    <span className="label">Total:</span>
                    <span className="value">{values.size} Gb</span>
                </div>
                <div className="stat-row">
                    <span className="label">Free:</span>
                    <span className="value">{values.available} Gb</span>
                </div>
                <div className="stat-row">
                    <span className="label">Used:</span>
                    <span className="value">{values.used} Gb</span>
                </div>
                <div className="stat-row">
                    <span className="label">Write:</span>
                    <span className="value">{values.wxSec} Mb/s</span>
                </div>
                <div className="stat-row">
                    <span className="label">Read:</span>
                    <span className="value">{values.rxSec} Mb/s</span>
                </div>
            </div>

            <div className="oct_sys-chart-pie-wrapper-v2 mt-2">
                <ResponsiveContainer width="100%" height={100}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={30}
                            outerRadius={45}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            <Cell fill="#ef4444" />
                            <Cell fill="#e2e8f0" />
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className="oct_sys-chart-legend-v2">
                <div className="legend-item">
                    <div className="color-box red"></div>
                    <span>Used</span>
                </div>
                <div className="legend-item">
                    <div className="color-box slate"></div>
                    <span>Free</span>
                </div>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    const pageData = state.systemPage;
    const data = pageData.disk;
    return {
        size: Number(data.size * 0.000001 * 0.001).toFixed(2),
        used: Number(data.used * 0.000001 * 0.001).toFixed(2),
        available: Number(data.available * 0.000001 * 0.001).toFixed(2),
        rxSec: Number(data.rxSec * 0.000001).toFixed(2),
        wxSec: Number(data.wxSec * 0.000001).toFixed(2),
    }
}

export default connect(mapStateToProps)(DiskUsageChart);